module.exports = __webpack_public_path__ + "img/Hummingbirds_3.d8302141.png";